// @flow

export const isValidPhoneNumber = (
  countryCode: string,
  phoneNumber: string
) => {
  const number = parseInt(phoneNumber, 10);
  switch (countryCode) {
    case '91':
      // Indian mobile number validation
      return !isNaN(number) && number.toString().length === 10;
    case '971':
      // UAE mobile number validation
      return !isNaN(number) && number.toString().length === 9;
    default:
      return true;
  }
};
